import { load } from './botd';
export async function isRobot() {
  const botd = await load();
  return botd.detect()
}